"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../../Button"));
var FooterFilter = function FooterFilter(_ref) {
  var locale = _ref.locale,
    confirm = _ref.confirm,
    clearFilters = _ref.clearFilters;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-buttons"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    type: "primary",
    className: "right-floated",
    onClick: confirm
  }, locale.filterConfirm), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    link: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      clearFilters();
    }
  }, locale.filterReset));
};
var _default = exports.default = FooterFilter;